const doc = [({"en":({"js":({"merfoto":({"welcome":({"your_photos":"Your photos", "products":"Products", "photos_available_at":"The photos are available at %{photosAvailableAt}."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;